import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export function useAdminExportDeleteBatchHistory() {
    const { oktaAuth } = useOktaAuth();

    function AdminExportDeleteBatchHistory(inputParameters) {
        let accessToken = oktaAuth.getAccessToken();

        let apiParameters = {
            user: inputParameters.user,
            batchIds: inputParameters.batchIds,
        };

        axios.post(
            "api/RemittanceExport/DeleteBatches",
            apiParameters,
            {
                headers: { Authorization: `Bearer ${accessToken}` },
            })
            .then((response) => {
                console.log("Post request successful:", response);
                inputParameters.callback();
            })
            .catch((e) => {
                console.log("Post request failed:", e);
            });
    }

    return useMutation({
        mutationFn: async (mutateParameter) => {
            AdminExportDeleteBatchHistory(mutateParameter);
        }
    });

}